import type { ActionSource as ActionSourceAnalyticsActions } from "owa-analytics-types";
import type { ActionSource as ActionSourceMailStore } from "owa-mail-store";
import { lazyOnDelete } from "owa-mail-commands-actions";
import type { IncompleteGroupHeaderInfo } from "owa-mail-triage-action-utils/lib/IncompleteGroupHeaderInfo";

export default function onDelete(actionSourceMailStore: ActionSourceMailStore, actionSourceAnalyticsActions: ActionSourceAnalyticsActions, isExplicitSoftDelete?: boolean, targetWindow?: Window, rowKeysToUse?: string[], incompleteGroupHeaderInfo?: IncompleteGroupHeaderInfo): void {
    lazyOnDelete.importAndExecute(actionSourceMailStore, actionSourceAnalyticsActions, isExplicitSoftDelete, targetWindow, undefined, // tableViewToUse
    rowKeysToUse, undefined, // isInVirtualSelectAllModeToUse
    undefined, // selectedNodeIdsToUse
    undefined, // virtualSelectAllExclusionListToUse
    incompleteGroupHeaderInfo);
}
